export default __webpack_public_path__ + "static/media/gp-white.c484151c.svg";